module.exports = __webpack_public_path__ + "static/magda-6fdf0853cef2ee90e24820ec416f7d7c.jpg";